import { Module } from 'wrapper6'

export default class PartnerAds extends Module {
  paidKey = 'partner-ads-paid'
  pacidKey = 'partner-ads-pacid'

  ready() {
    const urlParams = new URLSearchParams(window.location.search)
    const paidValue = urlParams.get('paid')
    const pacidValue = urlParams.get('pacid')

    if (paidValue === null) {
      return
    }

    const dateIn40Days = new Date()
    dateIn40Days.setTime(dateIn40Days.getTime() + (40 * 24 * 60 * 60 * 1000))

    this.saveCookiesOnLoad(paidValue, pacidValue, dateIn40Days)
    this.saveMarketingCookieOnAccept(pacidValue, dateIn40Days)
    this.removeMarketingCookieOnDecline()
  }

  saveCookiesOnLoad(paidValue, pacidValue, dateIn40Days) {
    document.cookie = `${this.paidKey}=${paidValue}; expires=${dateIn40Days.toUTCString()}; path=/`

    if (pacidValue !== null && window.Cookiebot?.consent?.marketing) {
      document.cookie = `${this.pacidKey}=${pacidValue}; expires=${dateIn40Days.toUTCString()}; path=/`
    } else {
      this.removeMarketingCookie()
    }
  }

  saveMarketingCookieOnAccept(pacidValue, dateIn40Days) {
    const that = this

    window.addEventListener('CookiebotOnAccept', function (e) {
      if (window.Cookiebot?.consent?.marketing) {
        document.cookie = `${that.pacidKey}=${pacidValue}; expires=${dateIn40Days.toUTCString()}; path=/`
      } else {
        that.removeMarketingCookie()
      }
    }, false)
  }

  removeMarketingCookieOnDecline() {
    const that = this

    window.addEventListener('CookiebotOnDecline', function (e) {
      that.removeMarketingCookie()
    }, false)
  }

  removeMarketingCookie() {
    document.cookie = `${this.pacidKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }
}
